import { defineModule } from "@motolynk/app-core";

import en from "./i18n/en.json";

const requires = [
  "core",
  "geo",
  "accounts",
  "configuration",
  "audit",
  "medialib",
  "notifications",
  "vehicles",
  "taxes",
  "catalog",
  "vendors",
  "products",
  "logistics",
  "cart",
  "payments",
  "payouts",
  "orders",
];

/** Returns & exchanges (P5-04, optional): admin step 14 and vendor step 13; the customer's pages come in P6-10. */
export const returnsModule = defineModule({
  name: "returns",
  label: "Returns & exchanges",
  requires,
  i18n: { en },
  admin: {
    routes: [
      {
        path: "returns",
        permission: "returns.view_returnrequest",
        page: () => import("./admin/ReturnsPage"),
      },
      {
        path: "returns/:number",
        permission: "returns.view_returnrequest",
        page: () => import("./admin/ReturnPage"),
      },
    ],
    nav: [
      {
        id: "returns",
        group: "business",
        label: "returns:nav.returns",
        icon: "undo",
        to: "/returns",
        permission: "returns.view_returnrequest",
        order: 2,
      },
    ],
  },
  vendor: {
    routes: [
      { path: "returns", permission: "orders.manage", page: () => import("./vendor/ReturnsPage") },
      {
        path: "returns/:number",
        permission: "orders.manage",
        page: () => import("./vendor/ReturnPage"),
      },
    ],
    nav: [
      {
        id: "returns",
        group: "sales",
        label: "returns:nav.returns",
        icon: "undo",
        to: "/returns",
        permission: "orders.manage",
        order: 20,
      },
    ],
  },
});
